// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 134 ? "screen-orientation-js" : chunkId) + "." + {"134":"4c8170b5","845":"07b81080"}[chunkId] + ".chunk.js";
};